<template>
  <div>
    <breadcrumb :list="breadcrumbList"></breadcrumb>
    <el-card class="main">
      <div class="subject">
        <el-row type="flex" class="subject_title">
          <img src="@/assets/img/tag.png" alt="" />
          <span class="title_text">基本信息</span>
        </el-row>

        <el-descriptions
          class="margin-top"
          :column="3"
          border
          labelClassName="labelWidth"
          contentClassName="contentStyle"
        >
          <el-descriptions-item label="营业日志编号">{{
            list.id
          }}</el-descriptions-item>
          <el-descriptions-item label="营业场所编号">{{
            list.cs_dmsn
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="场所负责人">{{
            list.csfzr
          }}</el-descriptions-item>
          <el-descriptions-item label="治安负责人">
            {{ list.zafzr }}</el-descriptions-item
          > -->
          <el-descriptions-item label="营业开始时间">
            {{ list.begintime | formatDate }}</el-descriptions-item
          >
          <el-descriptions-item label="营业结束时间">
            {{ list.endtime | formatDate }}</el-descriptions-item
          >
          <!--  -->
          <el-descriptions-item label="是否有治安/刑事/事故">
            {{ list.ajfs | sfFilter }}</el-descriptions-item
          >
          <el-descriptions-item label="事故内容">
            {{ list.ajdescribe }}</el-descriptions-item
          >
          <el-descriptions-item label="是否有管理部门检查">
            {{ list.ischeck | sfFilter }}</el-descriptions-item
          >
          <el-descriptions-item label="检查部门">
            {{ list.jcbm }}</el-descriptions-item
          >
          <el-descriptions-item label="是否发现问题">
            {{ list.jcwt }}</el-descriptions-item
          >
          <el-descriptions-item label="当日营业状态">
            {{ list.businessdesc }}</el-descriptions-item
          >
          <!--  -->
          <el-descriptions-item label="创建人">
            {{ list.username }}</el-descriptions-item
          >
          <el-descriptions-item label="创建人账号">
            {{ list.mobile }}</el-descriptions-item
          >
          <el-descriptions-item label="创建时间">
            {{ list.createtime | formatDate }}</el-descriptions-item
          >
          <!--  -->

          <!--  -->
        </el-descriptions>
        <el-row type="flex" class="subject_title" style="padding: 18px 0 23px">
          <img src="@/assets/img/tag.png" alt="" />
          <span class="title_text">当日上班人员</span>
        </el-row>
        <el-table
          class="empTable"
          :data="enforce_person"
          style="width: 100%;"
          :header-cell-style="{ background: '#F1F2F7', color: '#606266' }"
        >
          <el-table-column prop="ye_empname" label="姓名" align="center">
          </el-table-column>
          <el-table-column
            prop="cyry_gwms"
            label="工作职责"
            align="center"
            class-name="column-bg-color-editable"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column prop="ye_address" label="工作地点" align="center">
          </el-table-column>
          <el-table-column prop="ye_stime" label="工作开始时间" align="center">
            <template slot-scope="data">
              {{ day(data.row.ye_stime) }}
            </template>
          </el-table-column>
          <el-table-column prop="ye_etime" label="工作结束时间" align="center">
            <template slot-scope="data">
              {{ day(data.row.ye_etime) }}
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="subject_btn" style="text-align:center;margin-top: 56px;">
        <!-- <el-button type="info" @click="goBack">返回</el-button>  2020-06-02 产品去掉-->
        <el-button type="primary" @click="$router.back(-1)" class="go_back"
          >返回</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
import { getYylogItem } from '@/api/day_work.js'
import { lists, filtersInfo } from '@/utils/dictionary.js'
import dayjs from 'dayjs'
let that
export default {
  name: 'EmployeesDetailsVue',
  data() {
    return {
      breadcrumbList: [
        { name: '营业日志', path: 'bus_log' },
        { name: '查看', path: 'bus_log/bus_log_details' }
      ],
      list: [],
      sfList: [],
      id: null,
      loading: true,
      enforce_person: []
    }
  },
  beforeCreate() {
    that = this
  },
  created() {
    this.info()
  },
  methods: {
    day(data) {
      if (Number(data)) {
        return dayjs.unix(data).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return ''
      }
    },
    async info() {
      this.id = this.$route.query.id
      this.list = await getYylogItem(this.id)
      this.sfList = lists['SF']
      console.log('this.list', this.list.employee)
      this.enforce_person = this.list.employee
    }
  },
  filters: {
    sfFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.sfList, val)
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  margin: 20px;
  padding: 22px 20px;

  .subject {
    .subject_title {
      margin-bottom: 23px;

      img {
        width: 30px;
        height: 39px;
        margin-right: 3px;
      }

      .title_text {
        font-size: 18px;
        line-height: 36px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #6345d5;
      }
    }
  }

  /deep/ .labelWidth {
    width: 9vw;
  }

  /deep/ .contentStyle {
    width: 18vw;
  }

  .go_back {
    width: 80px;
    height: 50px;
    background: #ffffff;
    border: 1px solid #6345d5;
    border-radius: 6px;
    color: #6345d5;
  }
}
</style>
